export const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

export const PICKERS = {
    day: 'day',
    month: 'month',
    year: 'year'
};

export const DATE_PART = {
    day: 'DD',
    month: 'MM',
    year: 'YYYY'
};

export const RANGE = Object.freeze({
    PAST: 'PAST',
    FUTURE: 'FUTURE'
});

// TotalCasino changes
export const UNLIMITED_DEFAULT = 9999;
export const UNLIMITED_DAY = 9999;
export const UNLIMITED_MONTH = 10000;
export const UNLIMITED_YEAR = 9999;
